import { useSelector } from 'react-redux';

// Returns boolean if user has a permission from profile.permissions
export const usePermission = (permission) => {
  const user = useSelector((state) => state.auth.user);
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  return Boolean(permission && permissions.includes(permission));
};

// Returns true if user has ALL permissions
export const usePermissionsAll = (perms = []) => {
  const user = useSelector((state) => state.auth.user);
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  return perms.every((p) => permissions.includes(p));
};

// Returns true if user has ANY of the permissions
export const useAnyPermission = (perms = []) => {
  const user = useSelector((state) => state.auth.user);
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  return perms.some((p) => permissions.includes(p));
};

// Enhanced permission hook that matches the guide's specification
export const usePermissions = (perms = []) => {
  const user = useSelector((state) => state.auth.user);
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  return perms.every((p) => permissions.includes(p));
};

// Get user's groups
export const useUserGroups = () => {
  const user = useSelector((state) => state.auth.user);
  return Array.isArray(user?.groups) ? user.groups : [];
};

// Check if user belongs to specific groups
export const useHasGroup = (groupName) => {
  const groups = useUserGroups();
  return groups.includes(groupName);
};

// Check if user has any of the specified groups
export const useHasAnyGroup = (groupNames = []) => {
  const groups = useUserGroups();
  return groupNames.some((group) => groups.includes(group));
};

